// /////////////////////////////////////////////////////////////
// [ファイル] SalesProjectPhaseChip.tsx
// [概要] 営業案件フェーズ（成約確度）を色分け Chip で表示
// /////////////////////////////////////////////////////////////
import React from 'react';
import { Chip, ChipProps, SxProps, Theme } from '@mui/material';
import { PHASE_COLORS, Phase } from '../constants/masterData';

interface SalesProjectPhaseChipProps {
  phase: string | null | undefined;
  size?: ChipProps['size'];
  sx?: SxProps<Theme>;
}

export default function SalesProjectPhaseChip({ phase, size = 'small', sx }: SalesProjectPhaseChipProps) {
  if (!phase) return null;
  const color = PHASE_COLORS[phase as Phase];
  return (
    <Chip
      label={phase}
      size={size}
      sx={{
        bgcolor: color?.bg ?? '#eeeeee',
        color: color?.fg ?? '#444444',
        fontWeight: 600,
        fontSize: '0.75rem',
        borderRadius: '6px',
        height: 22,
        '& .MuiChip-label': { px: 1 },
        ...sx,
      }}
    />
  );
}
